/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */

import Grid from './Grid';
import DummyCreate from './Create';
import { NavLink } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import SideDrawer from './../../Components/SideDrawer';
import { useSelector, useDispatch } from 'react-redux';
import ContentWrapper from '../../Layouts/AdminLTE/ContentWrapper';
import { LoadResourceAction } from '../../Redux/Actions/CrudActions';


export default function DummyIndex(props) {

    const PageName = 'Dummy';
    const CreateNewButtonName = 'Create New Dummy';
    const BACKEND_ROUTE = 'dummies';
    const ACTION_TYPE = "COMMON";

    const [tablecolumn, setTablecolumn] = useState({
        columns: [
            { title: 'Id', field: 'id' },
            { title: 'Dummy Name', field: 'name' },
            { title: 'Description', field: 'description' },
            { title: 'Date', field: 'date' },
            { title: 'created At', field: 'created_at' },
            { title: 'updated At', field: 'updated_at' },
            { title: 'User ID', field: 'user_id' },
        ]
    });

    const [data, setData] = useState([]);

    const [DrawerCreateStatus, setDrawerCreateStatus] = useState(false);

    const state = useSelector(state => state.common);

    const dispatch = useDispatch();

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE, signal));
        return () => {
            controller.abort();
            console.log("Aborted Customer");
        }
    }, []);

    useEffect(() => {
        if (state.all.success && state.all.list) {
            setData(state.all.list);
            dispatch({type:`RESTART_${ACTION_TYPE}_LIST`});
        }
    }, [state]);

    const HandleDrawerCreate = () => {
        if (DrawerCreateStatus === false) {
            setDrawerCreateStatus(true);
        } else if (DrawerCreateStatus === true) {
            setDrawerCreateStatus(false);
        }
    }

    return (
        <ContentWrapper page_name={PageName} breadcrumbs={breadcrumbs(PageName)}>
            <div className="card rounded">
                <SideDrawer 
                    status={DrawerCreateStatus} 
                    action_heading={CreateNewButtonName} 
                    handle={HandleDrawerCreate}>
                    {DrawerCreateStatus && <DummyCreate />}
                </SideDrawer>
                <div className="card-body p-0">
                    <Grid
                        dataList={data}
                        setDataList={setData}
                        columns={tablecolumn}
                        Title={PageName}
                        HandleDrawerCreate={HandleDrawerCreate}
                    />
                </div>
            </div>
        </ContentWrapper>
    );
};
function breadcrumbs(PageName, IndexRoute = false, IndexPageName = false) {
    return (
        <>
            {IndexPageName && <li className="breadcrumb-item">
                <NavLink to={IndexRoute}>{IndexPageName}</NavLink></li>}
            <li className="breadcrumb-item active">{PageName}</li>
        </>
    )
}
